export const THEMES = {
  DARK: 'DARK'
};

export const ENABLE_REDUX_DEV_TOOLS = true;

export const DELIVERY_TYPE = [
  {
    value: "CU",
    label: "Courier"
  },
  {
    value: "SL",
    label: "SL Post"
  }
];

export const COURIER_IDS = [
  "65dcda0464359aa45b0a36c1",
  "67a31ed4f021756cb8c76d46",
  "68e6a0b7a298b04be8e2c6cd"
];
